import SectionHeading from "@/components/base/SectionHeading";
import { protagonist } from "@/mocks/comicData";

export default function Protagonist() {
  return (
    <section id="protagonist" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="主角介绍"
          title="林屿：从抗拒到接纳的少年"
          description="他是全书的核心视角，也是串联起继母苏婉、继姐苏念两个家庭的纽带。理解林屿，就理解了整部漫画的情感脉络。"
        />

        <div className="mt-10 md:mt-14 grid items-center gap-8 lg:grid-cols-[380px_1fr] md:gap-10">
          <div className="relative">
            <div className="absolute -inset-3 rounded-2xl bg-gradient-to-br from-primary-200 via-accent-100 to-secondary-200 opacity-70"></div>
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={protagonist.image}
                alt={`继母与继姐漫画主角 ${protagonist.name} 角色立绘`}
                className="h-[420px] w-full object-cover object-top"
              />
            </div>
            <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
              主角 · {protagonist.name}
            </span>
          </div>

          <div className="flex flex-col gap-5">
            <blockquote className="border-l-4 border-accent-500 pl-4 font-heading text-lg md:text-xl font-semibold text-foreground-900 italic leading-relaxed">
              「{protagonist.quote}」
            </blockquote>

            <div className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-600">
              <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-3 py-1">
                <i className="ri-user-heart-line text-primary-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                {protagonist.age}
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-3 py-1">
                <i className="ri-compass-3-line text-accent-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                {protagonist.role}
              </span>
            </div>

            <p className="text-sm md:text-base leading-relaxed text-foreground-700">
              {protagonist.description}
            </p>

            <div>
              <h3 className="mb-3 text-sm font-semibold text-foreground-900">性格标签</h3>
              <div className="flex flex-wrap gap-2">
                {protagonist.traits.map((trait) => (
                  <span
                    key={trait}
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs md:text-sm font-medium text-secondary-900"
                  >
                    {trait}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {[
                { label: "与继母", value: "客套 → 信任" },
                { label: "与继姐", value: "疏离 → 并肩" },
                { label: "与父亲", value: "沉默 → 理解" },
              ].map((item) => (
                <div key={item.label} className="rounded-lg bg-background-100 px-3 py-3 text-center">
                  <div className="text-xs text-foreground-500">{item.label}</div>
                  <div className="mt-1 text-xs md:text-sm font-semibold text-primary-700">
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}